import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Utilizziamo i cookie',
    description:
      'Utilizziamo cookie e tecnologie simili per offrire questa esperienza. I cookie strettamente necessari sono sempre attivi.',
    allow_label: 'Accetta tutti i cookie',
    reject_label: 'Solo quelli strettamente necessari',
    settings_label: 'Impostazioni cookie',
    policy_link_label: 'Informativa sulla privacy e sui cookie',
    categories_label: 'Categorie',
    always_on_label: 'Sempre attivi',
    required_label: 'Obbligatori',
    save_preferences_label: 'Salva preferenze',
    close_label: 'Chiudi',
    allow_all_optional_categories_label: 'Consenti tutte le categorie facoltative',
    settings_title: 'Impostazioni cookie',
    settings_description:
      'Utilizziamo cookie e tecnologie simili per offrire questa esperienza. I cookie strettamente necessari sono sempre attivi.',
    save_error: 'Non è stato possibile salvare la tua scelta sulla privacy. Riprova.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strettamente necessari',
      purpose: 'Necessari per offrire questa esperienza e non possono essere disattivati.'
    },
    analytics: {
      name: 'Analisi',
      purpose: 'Misura come i visitatori usano questa esperienza per migliorarne le prestazioni.'
    },
    marketing: { name: 'Marketing', purpose: 'Supporta pubblicità e marketing scelti dall’organizzatore.' }
  }
};

export default locale;
